var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconPCard = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.3012 12.5039H12.6988C11.2083 12.5039 10 13.7122 10 15.2027V15.3721C10 15.6313 10.2102 15.8414 10.4694 15.8414H29.5306C29.7898 15.8414 30 15.6313 30 15.3721V15.2027C30 13.7122 28.7917 12.5039 27.3012 12.5039Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 20.4309C10 20.8845 10.3677 21.2522 10.8214 21.2522H16.2964L20.4172 25.5565C20.5729 25.7298 20.7947 25.8283 21.0278 25.8283H27.3012C28.7917 25.8283 30 24.6201 30 23.1295V17.9537C30 17.6945 29.7898 17.4844 29.5306 17.4844H10.4694C10.2102 17.4844 10 17.6945 10 17.9537L10 20.4309Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3538 24.5638C17.279 24.4468 17.4137 24.5958 15.5742 22.7562C15.2534 22.4354 14.7334 22.4354 14.4126 22.7562C14.0918 23.077 14.0918 23.597 14.4126 23.9178L14.6793 24.1845L10.8214 24.1844C10.3691 24.1844 10 24.5508 10 25.0058C10 25.4594 10.3677 25.8272 10.8214 25.8272L14.6792 25.8273L14.4127 26.0937C14.0919 26.4144 14.0918 26.9344 14.4126 27.2552C14.7333 27.576 15.2533 27.5762 15.5742 27.2554C17.3832 25.4468 17.2826 25.5603 17.3549 25.4464C17.5294 25.1727 17.523 24.8279 17.3538 24.5638Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconPCard);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_p_card.127f9ad2b2787aad2bb220d17be2b7a1.svg";